import React from 'react'

import TextToTextTransformerLayout from '../../../components/layouts/TextToTextTransformerLayout'


export default function HashGeneratorLayout({generateHash}) {
  return (
    <TextToTextTransformerLayout
      transform={generateHash}
      transformOptions={{
        skipEmpty: false
      }}
    />
  )
}

